import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Components from './components/_index'
import VueGtag from 'vue-gtag'

require('@/styles/main.css')

Object.keys(Components).forEach((key) => {
  Vue.component(key, Components[key])
})

Vue.use(VueGtag, {
  config: {id: 'G-EKRMYZF4D2'},
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
